import { Grid, Typography } from '@mui/material';
import useTranslate from 'Hooks/useTranslate';
import { useStyles } from '../../Directories.styles';
import { DirectoryAvatar } from 'Theme/components/Avatar';
import TestIds from 'Tests/TestIds';
import { Imgs } from 'Assets';
import DirectoryExtraInfoBlock from '../../DirectoryExtraInfoBlock';

interface Props {
  directory: IDirectoryAuthenticatingPersonType;
  hasSuperRights: boolean;
  index: number;
}

function UnroutableDirectory(props: Readonly<Props>) {
  const ts = useTranslate();
  const classes = useStyles();
  const { directory, hasSuperRights, index } = props;

  return (
    <Grid
      item
      container
      direction="row"
      alignItems="center"
      className={classes.smColumn}
      data-testid={
        TestIds.pages.profile.directories.directoriesListItem + index
      }
    >
      <Grid item container sm={9} alignItems="center" direction="row">
        <Grid item>
          {directory.identifier?.toLowerCase() === 'lbp' ? (
            <img
              src={Imgs.lbpLogo.src}
              alt={Imgs.lbpLogo.alt}
              className={classes.logo}
            />
          ) : (
            <DirectoryAvatar directory={directory} size="larger" />
          )}
        </Grid>
        <Grid item className={classes.infoText}>
          <Typography variant="body2">{directory.label}</Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ fontStyle: 'italic' }}
          >
            {ts('page.userProfile.unroutableDirectoryConnection', {
              dir: directory.label
            })}
          </Typography>
          {hasSuperRights && (
            <DirectoryExtraInfoBlock
              directory={directory}
              index={index}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default UnroutableDirectory;
